let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fDZox")).then(() => parcelRequire('5zdhe'));